import _ from 'lodash'
import { DATE, DATE_TIME, TIME, YES_NO } from 'scoreboard/datasets/model/data-type'
import isGeographicOrRollup from 'scoreboard/datasets/is-geographic-or-rollup'
import isDateTimeDataType from 'scoreboard/components/is-date-time-data-type'
import Dataset from 'scoreboard/datasets/model/dataset'
import constants from 'scoreboard/components/constants'

const SOURCE_WIDGET_FILTER = 'source-widget-filter'

/**
 * Builds a filter for a dashboard form widget based on the current value of
 * another widget (ie the filterSourceWidgetId)
 *
 * @param {DatasetField} field
 * @param {*|Array<*>}} currentValue
 * @param {Dataset} dataset
 *
 * @return {ApiDatasetFilter}
 */
function buildDashboardWidgetFilter ({ field, currentValue, dataset }) {
	if (!field) {
		return null
	}

	let filter = {
		cid: SOURCE_WIDGET_FILTER,
		fieldId: field.id,
		linkGroup: constants.SOURCE_WIDGET_FILTER_LINK_GROUP,
		drawerFilter: true
	}

	let underlyingField = dataset.getUnderlyingField(field)

	let rawValues = _.isArray(currentValue)
		? currentValue : [ currentValue ]
	rawValues = rawValues.filter(value => {
		return !_.isNil(value) && value !== '' && !_.isNaN(value)
	})

	let dataType = underlyingField.dataType

	if (rawValues.length === 0) {
		applyBlank(filter, dataType)
		return filter
	}

	switch (dataType) {
		case TIME:
			applyTimes(filter, rawValues); break
		case DATE:
		case DATE_TIME:
			applyDateTimes(filter, rawValues); break
		case YES_NO:
			applyYesNo(filter, rawValues); break
		default:
			if (isGeographicOrRollup(dataType)) {
				applyRollupToFilter(filter, rawValues)
			} else {
				filter.operator = 'is-any'
				filter.values = rawValues
			}
	}

	return filter
}

function applyBlank (filter, dataType) {
	if (isDateTimeDataType(dataType) || isGeographicOrRollup(dataType)) {
		filter.operator = 'is-blank'
	} else {
		filter.operator = 'is-any'
		filter.values = [Dataset.BLANK]
	}
}

function applyYesNo (filter, rawValues) {
	filter.operator = 'is-any'
	filter.values = rawValues.map(value => {
		// The yes/no values always seem to come in as true/false Strings, so we'll
		// just handle that for now
		switch (value) {
			case 'true': return 'yes'
			case 'false': return 'no'
			default: return value
		}
	})
}

function applyDateTimes (filter, rawValues) {
	filter.operator = 'on-any-date'
	filter.dates = rawValues
}

function applyTimes (filter, rawValues) {
	filter.operator = 'at-any-time'
	filter.times = rawValues
}

function applyRollupToFilter (filter, rawValues) {
	filter.operator = 'is-any'
	filter.rollupIsAnyFilters = _(rawValues)
		.map(id => [id, 'item-rollups-and-descendants'])
		.fromPairs()
		.value()
}

export default buildDashboardWidgetFilter
export { SOURCE_WIDGET_FILTER }

buildDashboardWidgetFilter.__filename__ = 'forms/widgets/build-dashboard-widget-filter.js'
